import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import fontNormal from '../../application/fonts/MetaOffcPro-Norm.ttf';
import fontBold from '../../application/fonts/MetaOffcPro-Bold.ttf';
import moment from 'moment';
import {createApp} from "vue";
import {createBootstrap} from "bootstrap-vue-next";
import SearchBar from "../../application/utility/SearchBar.vue";

$(document).ready(/(\/student-management\/((enrolment(\/\d+)?\/tor)|(my-performances))\/\d+(\/view)?)/
    .test(window.location.pathname)&&function() {
  const container = $('#search-bar-container');

  createApp(SearchBar, container.data())
      .use(createBootstrap())
      .mount(container[0]);

  const generatePDF = async function() {
    // create jsPDF document
    const doc = new jsPDF({
      orientation: 'landscape',
      unit: 'mm',
      format: 'a4',
    });

    // add fonts
    doc.addFont(fontNormal, 'MetaOffcPro', 'normal');
    doc.addFont(fontBold, 'MetaOffcPro', 'bold');

    // print heading
    doc.setFont('MetaOffcPro', 'normal');
    doc.setFontSize(15);
    const heading = $('#tableExportStudentData li[data-name="heading"]')[0].innerHTML;
    const subheading = $('#tableExportStudentData li[data-name="subheading"]')[0].innerHTML;
    doc.text(heading, 10, 10);
    doc.setFontSize(8);
    doc.text(subheading, 10, 13.3);

    // fetch complete html page and get table dom element
    const table = await fetch(location.pathname + '?complete=1')
        .then((res) => res.text())
        .then(function(text) {
          const parser = new DOMParser();
          const html = parser.parseFromString(text, 'text/html');
          return html.getElementById('table');
        })
        .catch(function(err) {
          console.error(err);
          return null;
        });

    if (table === null) {
      alert('Die benötigten Daten konnten nicht heruntergeladen werden.');
      return;
    }

    // change column heading to Gew. and delete edit column
    table.rows[0].cells[4].innerHTML = 'Gew.';
    Array.from(table.querySelectorAll('.hidden-print')).forEach((elem) => elem.remove());

    // autotable definition
    autoTable(doc, {
      html: table,
      theme: 'grid',
      tableLineWidth: 0.2,
      margin: 5,
      startY: 15,
      styles: {
        lineColor: '#dee2e6',
        lineWidth: 0.2,
        cellWidth: 'wrap',
        cellPadding: 0.5,
        valign: 'middle',
        font: 'MetaOffcPro',
      },
      headStyles: {
        textColor: '#f8f9fa',
        fillColor: '#343a40',
        fontSize: 7,
      },
      bodyStyles: {
        fontSize: 6,
      },
      columnStyles: {
        2: {cellWidth: 63},
        3: {halign: 'right'},
        4: {halign: 'right'},
        5: {halign: 'right'},
        6: {cellWidth: 'auto'},
        8: {halign: 'center'},
        9: {halign: 'center'},
        10: {halign: 'center'},
      },
      didParseCell: (data) => {
        if (data.row.cells[0].colSpan === 3 && data.table.body[data.row.index + 1].cells[0].colSpan === 3) {
          data.cell.styles.fillColor = '#bdbdbd';
          if (data.column.index === 0 || data.column.index === 9 || data.column.index === 10) {
            data.cell.styles.fontStyle = 'bold';
          }
        } else if (data.row.cells[0].colSpan === 3) {
          data.cell.styles.fillColor = '#d6d8db';
        } else if (data.column.index === 0 && data.row.index !== 0) {
          data.cell.styles.halign = 'center';
          data.cell.text[0] = '-';
        }
      },
      didDrawPage: (data) => {
        const pageStr = 'Seite ' + doc.internal.getNumberOfPages() + ' von {total_pages}';
        const timeStampStr = 'Stand: ' + moment().format('DD.MM.YYYY, HH:mm') + ' Uhr';
        const pageWidth = doc.internal.pageSize.getWidth();
        const pageHeight = doc.internal.pageSize.getHeight();
        doc.setFontSize(6);
        doc.text(pageStr, data.settings.margin.left, pageHeight - 3);
        doc.text(timeStampStr, pageWidth - data.settings.margin.right, pageHeight - 3, 'right');
      },
      rowPageBreak: 'avoid',
      horizontalPageBreak: false,
    });
    doc.putTotalPages('{total_pages}');

    // output pdf
    const studentId = $('#tableExportStudentData li[data-name="studentId"]')[0].innerHTML;
    doc.output('dataurlnewwindow', {filename: 'Studienverlauf_'+ studentId + '.pdf'});
  };

  // add event listener to export button
  $('#table-export-btn')[0].addEventListener('click', generatePDF);
});
